export enum Side {
	BUY = "BUY",
	SELL = "SELL",
}
